import React  from 'react';
import styled, {css} from "styled-components"
import { NavLink} from "react-router-dom";
import {device} from "../device";

import SignUpForm from "./SignUpForm";
import {LoginContainer} from "./Navbar";
import {Connect} from "./Connect";


const MenuBtn = styled.button`
background: none;
border: none;
width: 80px;
cursor: pointer;
transform: scale(0.6);
position:fixed;
top:10px;
right:0;
z-index: 600 !important;

@media ${device.laptop} {
display: none;
}

  &:focus {
  outline: none;
  }
  
  span {
  display: block;
  width: 100%;
  border-radius: 3px;
  height: 8px;
  background: ${ ( {secondary, isMenuActive} ) => !secondary? "#fff" : isMenuActive? "#fff" : "#8F2699" };
  transition: all .3s;
  position: relative;
}

span + span {
  margin-top: 14px;
}
span:nth-child(1) {
  animation: ease .7s top-2 forwards;
}
span:nth-child(2) {
  animation: ease .7s scaled-2 forwards;
}
span:nth-child(3) {
  animation: ease .7s bottom-2 forwards;
}

${({isMenuActive}) => (
    isMenuActive && css`
span:nth-child(1) {
  animation: ease .7s top forwards;
}

span:nth-child(2) {
  animation: ease .7s scaled forwards;
}
span:nth-child(3) {
  animation: ease .7s bottom forwards;
}





`
)}




@keyframes top {
  0% {
    top: 0;
    transform: rotate(0);
  }
  50% {
    top: 22px;
    transform: rotate(0);
  }
  100% {
    top: 22px;
    transform: rotate(45deg);
  }
}

@keyframes top-2 {
  0% {
    top: 22px;
    transform: rotate(45deg);
  }
  50% {
    top: 22px;
    transform: rotate(0deg);
  }
  100% {
    top: 0;
    transform: rotate(0deg);
  }
}

@keyframes bottom {
  0% {
    bottom: 0;
    transform: rotate(0);
  }
  50% {
    bottom: 22px;
    transform: rotate(0);
  }
  100% {
    bottom: 22px;
    transform: rotate(135deg);
  }
}

@keyframes bottom-2 {
  0% {
    bottom: 22px;
    transform: rotate(135deg);
  }
  50% {
    bottom: 22px;
    transform: rotate(0);
  }
  100% {
    bottom: 0;
    transform: rotate(0);
  }
}

@keyframes scaled {
  50% {
    transform: scale(0);
  }
  100% {
    transform: scale(0);
  }
}

@keyframes scaled-2 {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
`

export const Menu = styled.div`
display: flex;
width: 100%;
height: 100%;
position:fixed;
top:0;
left:0;
background: #b52cc0;
z-index: 500;
flex-direction: column;
justify-content: center;
align-items: center;
transform: ${({isMenuActive}) => !isMenuActive ? "translateY(-110vh)" : "translateY(0)"};
transition: .5s all ease-in-out;
font-family: 'PT Sans Narrow', sans-serif;

a, span{
text-decoration: none;
font-size:3rem;
color:#fff;
margin:1.7rem 0;
display: flex;
flex-direction: column;

}



.active {
opacity: .5;
}


`


const Hamburger = ( {isMenuActive, setMenuActive, secondary, isLoginModalOpen,setLoginModalOpen, setKycModalOpen, isKycModalOpen} ) => {
    const pages = ["","Loans","Staking"]

    return (
        <>
            <MenuBtn isMenuActive={isMenuActive} onClick={() => setMenuActive(!isMenuActive)} secondary={secondary}>
                <span></span>
                <span></span>
                <span></span>
            </MenuBtn>
            <Menu isMenuActive={isMenuActive} setMenuActive={setMenuActive}>

                {pages.map(page =>
                    <NavLink key={page} to={`/${page}`} exact activeClassName="active"  onClick={()=> setMenuActive(false)}>{page===""? "Home" : page}</NavLink>
                )}
                <a href="#" onClick={()=>setMenuActive(false)} target="_blank" rel="noreferrer noopener">Twitter</a>
                <a href="#" onClick={()=>setMenuActive(false)} target="_blank" rel="noreferrer noopener">Telegram</a>
                <LoginContainer>
                        <span className="notlink"
                              onClick={() => {
                                  setMenuActive(false)
                                  setLoginModalOpen(!isLoginModalOpen)
                              }}>Sign Up / Kyc
                             </span>
                </LoginContainer>
                <Connect secondary/>

            </Menu>
            <SignUpForm isLoginModalOpen={isLoginModalOpen} setLoginModalOpen={setLoginModalOpen}/>

        </>
    );
};

export default Hamburger;